import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faBuilding, faCoins, faFileContract, faLaptopHouse, faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons";
import {faHome} from "@fortawesome/pro-regular-svg-icons";
import HomepageCooptation from "../../components/portfolio/Homepage/HomepageCooptation";
import UserProfileCard from "../../components/portfolio/UserProfileCard";
import { FormattedMessage } from "react-intl";
import JobsInterestSection from "../../components/portfolio/JobsPage/JobsInterestSection";
import { formatSalary } from "../../helpers/format";
import ContentLoader from "../../components/ContentLoader";
import MetaTags from '../../components/SEO/MetaTags'
import { Request } from '../../helpers/request'
import { Helmet } from 'react-helmet'
import { getLocalizedRoute } from '../../components/portfolio/LocaleSwitcher'
import LocaleLink, { addLocalePrefix } from '../../components/Routes/LocaleLink'
import DigitalJobsInterestSection from "../../components/portfolio/JobsPage/DigitalJobsInterestSection";
import JobsDetailPageComponent from "../../components/Jobs/JobsDetailPageComponent";

class JobDetailsPage extends Component
{
    state = {
        offer: null,
        linked_digital_jobs: null,
        linked_job_orders: null,
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const newProps = this.props;

        if(prevProps.match.params.slug !== newProps.match.params.slug) {
            Request.get('job_orders/slug/' + this.props.match.params.slug)
                .then((response) => this.setState({ ...response }))
                .catch(() => this.props.history.push(addLocalePrefix(`/404`)));
        }
    }

    componentDidMount() {
        Request.get('job_orders/slug/' + this.props.match.params.slug)
            .then((response) => this.setState({ ...response }))
            .catch(() => this.props.history.push(addLocalePrefix(`/404`)));
    }

    render() {
        const {offer} = this.state;
        if (!offer) return <ContentLoader/>;

        const metaDatas = {
            title: `${offer.title} - ${offer.address?.city}`,
            seo_title: offer?.seo_title,
            seo_description: offer?.seo_description,
            content: `Offre d\'emploi : ${offer.title} ${((offer.address?.city) ? 'à ' + offer.address.city : '')}'.' ${offer.hat}. Découvrez tous les détails et nos autres offres d\'emploi sur Urban Linker, cabinet de recrutement tech.`,
            hat: offer.hat
        }

        const alternateUrl = {
            fr: [window.location.origin, getLocalizedRoute(this.props.location.pathname, 'fr')].join(''),
            en: [window.location.origin, getLocalizedRoute(this.props.location.pathname, 'en')].join(''),
        }

        return (
            <div className="job-details-page">
                <MetaTags page="job_slug" data={metaDatas} />
                <Helmet>
                    <link rel="alternate" hrefLang="fr" href={alternateUrl.fr} />
                    <link rel="alternate" hrefLang="en" href={alternateUrl.en} />
                    <link rel="alternate" hrefLang="x-default" href={alternateUrl.fr} />
                </Helmet>

                <JobsDetailPageComponent offer={offer} jobSlug={this.props.match.params.slug}/>

                <JobsInterestSection business_unit={offer.business_unit} offer_id={offer.id} linked_job_orders={this.state?.linked_job_orders}/>
                {<DigitalJobsInterestSection linked_digital_jobs={this.state?.linked_digital_jobs} />}
                <HomepageCooptation offer={this.state.offer}/>

            </div>
        )
    }

    renderSkills() {
        const {skill_list} = this.state.offer;

        if (!skill_list) return null;

        return (
            <ul>
                {skill_list.split(',').map((skill, key) => {
                    if (!skill || skill.trim() === '') return;

                    return (
                        <li className="btn-regular" key={key}>
                            {skill}
                        </li>
                    )
                })}
            </ul>
        )
    }

    renderRemote() {
        const {open_to_remote} = this.state.offer;

        if (!open_to_remote) return null;

        switch (open_to_remote) {
            case "NONE":
                return (<p> <FontAwesomeIcon icon={faBuilding}/>
                    &nbsp; <FormattedMessage id="forms.remote.options.none" />
                </p>)
            case "PARTIAL":
                return (<p> <FontAwesomeIcon icon={faLaptopHouse}/>
                    &nbsp; <FormattedMessage id="forms.remote.options.partial" />
                </p>)
            case "FULL":
                return (<p><FontAwesomeIcon icon={faHome}/>
                    &nbsp; <FormattedMessage id="forms.remote.options.full" />
                </p>)
            default:
                return null
        }
    }
}

export default JobDetailsPage;
